module.exports = __webpack_public_path__ + "static/media/ic_p2off.cd6a6a48.png";